import _ from "lodash";
/** external */
import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { ToggleSwitch, Tooltip } from "@toddle-edu/ds-web";
/** internal */
import ConditionalWrapper from "Utils/ConditionalWrapper";
/** relative */
import classes from "./ToggleSwitchList.scss";

const styles = {
  overlayInnerStyle: {
    width: "248px",
    textAlign: "center",
  },
};

class ToggleSwitchList extends PureComponent {
  constructor(props) {
    super(props);

    if (props.customRef) {
      props.customRef(this);
    }
  }

  updateInputFieldCall = data => {
    const { value, updateInputField, fieldKey } = this.props;
    const modifiedValue = {
      [fieldKey]: {
        ...value,
        ...data,
      },
    };
    updateInputField({ params: modifiedValue, isDebounce: true });
  };

  handleToggleSwitch = (e, uid) => {
    const { options } = this.props;
    const toggleValue = e.target.checked;
    const value = { [uid]: toggleValue };

    //Fetch uids of settings that should be enabled when the current setting is disabled.
    const enableEntities = _.get(_.find(options, { uid }), "enableEntities");
    if (enableEntities && !toggleValue) {
      const id = enableEntities[0];
      value[id] = true;
    }
    this.updateInputFieldCall(value);
  };

  isValid = () => {
    return 0;
  };

  render() {
    const {
      value,
      t,
      options,
      toggleSwitchContainerStyle = {},
      labelComponent,
      isFromPrintSettings,
      disabled,
    } = this.props;

    const showLabelComponent =
      isFromPrintSettings && React.isValidElement(labelComponent);

    const subTextLable = classNames({
      "text-body-3": true,
      [classes.subText]: true,
    });
    const disableText = classNames({
      "text-body-1": true,
      [classes.disabledText]: isFromPrintSettings,
      [classes.subText]: !isFromPrintSettings,
    });
    const lableText = classNames({
      "text-body-1": true,
      [classes.subText]: isFromPrintSettings,
      [classes.lableText]: !isFromPrintSettings,
    });
    const optionClasses = classNames(classes.option, {
      [classes.applyBorder]: !isFromPrintSettings,
    });

    return (
      <>
        {showLabelComponent ? labelComponent : null}
        <div className={classes.container} style={toggleSwitchContainerStyle}>
          {_.map(options, option => {
            const toggleLabel = _.get(option, "toggleLabel", null);
            const subLabel = _.get(option, "subTextLocale", null);
            const uid = _.get(option, "uid", null);
            const toggleValue = _.get(
              value,
              uid,
              _.get(option, "defaultValue", false)
            );

            let disable = disabled;

            if (option?.dependentEntities) {
              const id = _.get(option, "dependentEntities[0]");
              const shouldBeActiveWhenDisabled = _.get(
                option,
                "shouldBeActiveWhenDisabled"
              );
              const settingValue = _.get(value, id);
              disable = !settingValue;
              if (!_.isBoolean(settingValue)) {
                disable = !_.get(
                  _.find(options, {
                    uid: id,
                  }),
                  "defaultValue"
                );
              }
              if (!shouldBeActiveWhenDisabled && disable && toggleValue) {
                this.handleToggleSwitch({ target: { checked: false } }, uid);
              }
            }
            const tooltip = _.get(option, "tooltip", "");
            const showTooltip = !_.isEmpty(tooltip) && disable;

            return toggleLabel ? (
              <div className={optionClasses}>
                <div className={classes.lableContainer}>
                  <div className={disable ? disableText : lableText}>
                    {t(toggleLabel)}
                  </div>
                  {subLabel ? (
                    <div className={subTextLable}>{t(subLabel)}</div>
                  ) : null}
                </div>
                <ConditionalWrapper
                  wrapper={
                    <Tooltip
                      tooltip={t(tooltip)}
                      placement="bottomRight"
                      overlayInnerStyle={styles.overlayInnerStyle}
                    />
                  }
                  condition={showTooltip}
                  type={"wrapperAsElement"}
                >
                  <ToggleSwitch
                    onChange={e => this.handleToggleSwitch(e, uid)}
                    checked={toggleValue}
                    disabled={disable}
                    testId={`worksheet-toggleSwitchList-${_.camelCase(
                      toggleLabel
                    )}`}
                  />
                </ConditionalWrapper>
              </div>
            ) : null;
          })}
        </div>
      </>
    );
  }
}

ToggleSwitchList.defaultProps = {
  options: [],
  isFromPrintSettings: false,
  disabled: false,
};

ToggleSwitchList.propTypes = {
  options: PropTypes.arrayOf(PropTypes.object),
  value: PropTypes.object,
  toggleSwitchContainerStyle: PropTypes.object,
  updateInputField: PropTypes.func,
  fieldKey: PropTypes.string,
  isFromPrintSettings: PropTypes.bool,
  disabled: PropTypes.bool,
};

export default ToggleSwitchList;
